import { MessagingPlatform } from '@this+that/models';

import { guardedIntegrationFetch } from './guardedIntegrationFetch';
import {
  TeamGithubState,
  useGetTeamGithubIntegrations,
} from '../../services/github.service';
import { useIntegrationsStore } from '../../store';

export const useGetGithubIntegrations = () => {
  const { getTeamGithubIntegrations } = useGetTeamGithubIntegrations();
  const { setTeamGithubIntegrations, setTeamGithubInstallationRequests } =
    useIntegrationsStore();

  const handleFetchGithubIntegrations = (
    teamId: string,
    forceRefresh = false,
  ) =>
    guardedIntegrationFetch({
      key: MessagingPlatform.GITHUB,
      scope: teamId,
      forceRefresh,
      fetch: () => getTeamGithubIntegrations(teamId),
      write: ({ integrations, installationRequests }: TeamGithubState) => {
        setTeamGithubIntegrations(integrations);
        setTeamGithubInstallationRequests(installationRequests);
      },
    });

  return { handleFetchGithubIntegrations };
};
